export enum WS_HANDLING_STATUS {
  DRAFT = 'DRAFT',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
